import { useContext } from "react";
import { CommandCenterStateProviderContext } from "../context";

const useError = () => {
    const context = useContext(CommandCenterStateProviderContext);

    if (context === undefined) {
        throw new Error('useError must be used within a ErrorProvider');
    }
    const { error, setError } = context;
    return { error, setError }
}

export default useError